import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Printer, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../lib/constants";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#050914] border-t border-white/10 relative grain"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="font-display font-bold text-xl tracking-[0.2em] uppercase text-white mb-6">
              Ferrer<span className="text-slate-400">·</span>Auto<span className="text-slate-400">·</span>Transport
            </div>
            <p className="text-slate-400 max-w-md leading-relaxed mb-8">
              Nationwide auto transport built on trust. Family-operated out of
              Woodbridge, New Jersey — moving vehicles safely across America
              since day one.
            </p>
            <Link
              to="/#quote"
              data-testid="footer-cta-quote"
              className="inline-flex items-center gap-3 bg-white text-[#050914] px-6 py-3 text-[12px] uppercase tracking-[0.2em] font-semibold hover:bg-slate-200 transition-colors"
            >
              Get a Free Quote <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.25em] text-slate-500 mb-5">Quick Links</div>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About Us" },
                { to: "/faq", label: "FAQ" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
                    className="text-slate-300 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.25em] text-slate-500 mb-5">Contact</div>
            <ul className="space-y-4 text-slate-300">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 text-slate-400 shrink-0" />
                <a href={`tel:${COMPANY.phoneRaw}`} data-testid="footer-phone" className="hover:text-white">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Printer className="w-4 h-4 mt-1 text-slate-400 shrink-0" />
                <span>Fax: {COMPANY.fax}</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 text-slate-400 shrink-0" />
                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="hover:text-white">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-slate-400 shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 justify-between text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Ferrer Auto Transport. All rights reserved.</div>
          <div className="uppercase tracking-[0.2em]">Licensed · Insured · Nationwide</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
